export const STUDY_MIN_VIEWPORT = Object.freeze({ width: 900, height: 560 });

function finiteDimension(value) {
  const number = Number(value);
  return Number.isFinite(number) ? Math.max(0, Math.round(number)) : 0;
}

export function readStudyViewport(browserWindow = typeof window !== "undefined" ? window : null) {
  if (!browserWindow) {
    return {
      width: 0,
      height: 0,
      visualWidth: 0,
      visualHeight: 0,
      visualScale: 1,
      devicePixelRatio: 1,
    };
  }

  const visualViewport = browserWindow.visualViewport;
  return {
    width: finiteDimension(browserWindow.innerWidth),
    height: finiteDimension(browserWindow.innerHeight),
    visualWidth: finiteDimension(visualViewport?.width || browserWindow.innerWidth),
    visualHeight: finiteDimension(visualViewport?.height || browserWindow.innerHeight),
    visualScale: Number.isFinite(visualViewport?.scale) ? visualViewport.scale : 1,
    devicePixelRatio: Number.isFinite(browserWindow.devicePixelRatio)
      ? browserWindow.devicePixelRatio
      : 1,
  };
}

export function isStudyViewportEligible(viewport) {
  return viewport.width >= STUDY_MIN_VIEWPORT.width
    && viewport.height >= STUDY_MIN_VIEWPORT.height;
}

export function studyViewportTelemetry(browserWindow = typeof window !== "undefined" ? window : null) {
  const viewport = readStudyViewport(browserWindow);
  return {
    viewport_width_px: viewport.width,
    viewport_height_px: viewport.height,
    visual_viewport_width_px: viewport.visualWidth,
    visual_viewport_height_px: viewport.visualHeight,
    visual_viewport_scale: viewport.visualScale,
    device_pixel_ratio: viewport.devicePixelRatio,
    source_layout_mode: isStudyViewportEligible(viewport) ? "pinned" : "incompatible",
  };
}
